<template>
  <view class="zds-refund-media" v-for="(item,idx) of model.mediaList" :key="idx">
    <template v-if="isVideo(item.materialUrl)">
      <video
        :src="item.materialUrl"
        controls
        width="200"
        height="200"
      ></video>
    </template>
    <el-image
      v-else
      style="width: 200px; height: 200px"
      :src="item.materialUrl"
      :preview-src-list="[item.materialUrl]">
    </el-image>
  </view>
  <template v-if="model.mediaList?.length === 0">
    <el-empty :image-size="200"></el-empty>
  </template>

</template>

<script setup lang="ts">
import {  onMounted } from 'vue' // 引入 onMounted

// const mediaList = ref([
//   'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
//   'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg',
//   'https://file-storage.gw-test.ztosys.com/wd01/dfs1415188289267027969/11949,2cc2214c4b1f0bb9a8727b38.mp4',
//   'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
//   'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg',
//   'https://file-storage.gw-test.ztosys.com/wd01/dfs1415188289267027969/11949,2cc2214c4b1f0bb9a8727b38.mp4'
// ])
import { ref, formatter, computed } from '@zto/zpage'

const props = withDefaults(
  defineProps<{
    model: any
  }>(),
  {
    model:{}
  }
)

const isVideo = (url:string) => {
  return false;
}

// 新增的 onload 功能
onMounted(() => {


  const data = props.model
  console.log('组件已加载，model 数据是:', props.model)
  console.log('mediaList:', props.model.mediaList)
  console.log('data:', data)
})
</script>

<style scoped lang="scss">
.zds-refund-media{
  margin: 20px 20px 0 0;
}
</style>
